<template>
  <div id="js-game-gallery" :class="$style.games">
    <the-game-gallery-bar-intro
      id="js-game-intro"
      :data="games"
      :active-index="activeIndex"
      :class="$style.intro"
    />
    <the-game-gallery-feature :data="games" />
    <the-game-gallery-bar
      id="js-game-bar"
      :data="games"
      :active-index="activeIndex"
      :class="$style.bar"
      @click="scrollTo"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheGameGalleryBarIntro from './TheGameGalleryBarIntro'
import TheGameGalleryFeature from './TheGameGalleryFeature'
import TheGameGalleryBar from './TheGameGalleryBar'

export default {
  components: {
    TheGameGalleryBarIntro,
    TheGameGalleryFeature,
    TheGameGalleryBar,
  },
  data() {
    return {
      activeIndex: 0, // 当前活动区域 id
      featureScenes: [],
      pinScenes: [],
      pinScenesData: ['bar', 'intro'],
    }
  },
  computed: {
    ...mapGetters(['games']),
    // 当前活动区域数据
    activeData() {
      return this.games[this.activeIndex] || {}
    },
  },
  mounted() {
    this.$nextTick(() => {
      /**
       * Add feature scene
       */
      this.featureScenes = this.games.map((el, index) => {
        const scene = this.$scrollmagic
          .scene({
            triggerElement:
              index === 0 ? '#js-app' : `#js-game-feature-${index}`,
            triggerHook: 0.5,
            duration: this.getFeatureDuration(index),
          })
          .setClassToggle(`#js-game-menu-${index}`, 'active')
          .on('enter', this.handleEnter)

        // indicator
        process.env.NODE_ENV === 'development' &&
          scene.addIndicators({ name: `game ${index}` })

        this.$scrollmagic.addScene(scene)

        return scene
      })

      /**
       * Add pin scene
       */
      this.pinScenes = this.pinScenesData.map((el) => {
        const scene = this.$scrollmagic
          .scene({
            triggerElement: '#js-game-gallery',
            triggerHook: 0,
            duration: this.getPinDuration(el),
          })
          .setPin(`#js-game-${el}`, { pushFollowers: false })

        // indicator
        process.env.NODE_ENV === 'development' &&
          scene.addIndicators({ name: `game pin ${el}` })

        this.$scrollmagic.addScene(scene)

        return scene
      })

      // 当窗口尺寸发生变化时重置 scene
      window.addEventListener('resize', this.resetScene)
    })
  },
  destroyed() {
    /**
     * Destroy feature scene
     */
    if (this.featureScenes.length > 0) {
      this.featureScenes.forEach((el) => {
        el.destroy(true)
      })
    }

    /**
     * Destroy pin scene
     */
    if (this.pinScenes.length > 0) {
      this.pinScenes.forEach((el) => {
        el.destroy(true)
      })
    }

    // remove resize
    window.removeEventListener('resize', this.resetScene)
  },
  methods: {
    handleEnter(event) {
      const id = event.target.triggerElement().id
      this.activeIndex = Number(id.split('-')[3]) || 0
    },
    scrollTo(index) {
      if (index !== this.activeIndex) {
        this.$scrollmagic.scrollTo(`#js-game-feature-${index}`)
      }
    },
    // 获取相对于文档最上方的高度差
    getOffsetTop(el) {
      return el.offsetParent
        ? el.offsetTop + this.getOffsetTop(el.offsetParent)
        : el.offsetTop
    },
    // 动态获取 feature duration
    getFeatureDuration(index) {
      const el = document.getElementById(`js-game-feature-${index}`)
      const height = el.clientHeight
      return index === 0 // 第一个游戏从文档顶部开始
        ? height + this.getOffsetTop(el)
        : // 最后一个游戏到文档底部结束
        index === this.games.length - 1
        ? 0
        : height
    },
    // 动态获取 pin duration
    getPinDuration(el) {
      return (
        document.getElementById('js-game-gallery').clientHeight -
        document.getElementById(`js-game-${el}`).clientHeight -
        150
      )
    },
    resetScene() {
      // 重置 feature scene
      if (this.featureScenes.length > 0) {
        this.featureScenes.forEach((el, index) => {
          el.duration(this.getFeatureDuration(index))
        })
      }

      // 重置 pin scene
      if (this.pinScenes.length > 0) {
        this.pinScenes.forEach((el, index) => {
          const id = this.pinScenesData[index]
          el.removePin(true)
          el.duration(this.getPinDuration(id))
          el.setPin(`#js-game-${id}`, { pushFollowers: false })
        })
      }
    },
  },
}
</script>

<style lang="less" module>
.games {
  position: relative;
  padding-top: @padding-base;
  margin-bottom: @padding-base;
}

@media screen and (max-width: @mini-width) {
  .intro,
  .bar {
    display: none;
  }
}
</style>
